import { useCallback } from 'sb-hooks'
import { ModalVisibilityProps } from 'sb-modal'
import { useConnect } from 'sb-redux-hook'
import request from 'sb-request'
import { useField } from 'formular'
import actions from 'redux/actions'
import { snowplow } from 'common/helpers'

import messages from './messages'
import unsubscribeFeedbackQuery from './unsubscribeFeedback.graphql'


export type SubscriptionWasCancelledModalProps = {}

const useSubscriptionWasCancelledModal = (props: SubscriptionWasCancelledModalProps & ModalVisibilityProps) => {
  const { closeModal, onClose } = props

  const commentsField = useField({
    value: '',
  })

  const { subscriptionId } = useConnect({
    subscriptionId: 'models.subscription.id',
  })

  const handleSubmit = useCallback(async () => {
    const comments = commentsField.state.value.trim()

    if (!comments) {
      closeModal()
    }

    if (comments) {
      try {
        actions.models.ui.showRequestLoader()

        snowplow.track('UF unsubscribe reason submit', { reason: comments })

        await request.gql('unsubscribeFeedback', {
          body: {
            query: unsubscribeFeedbackQuery,
            variables: {
              input: {
                feedback: comments,
                subscriptionId,
              },
            },
          },
          withNestedErrors: true,
        })

        actions.misc.notifications.show('alert', {
          title: messages.notificationTitle,
          text: messages.notificationText,
        })

        closeModal()
      }
      catch (error) {
        console.error(error)
      }
      finally {
        actions.models.ui.hideRequestLoader()
      }
    }
  }, [ closeModal, commentsField, subscriptionId ])

  return {
    commentsField,
    onSubmit: handleSubmit,
    onClose,
  }
}


export default useSubscriptionWasCancelledModal
